/**
 * 출퇴근 관리 API 서비스 (MYB-361)
 */
import { api } from './client';

export const attendanceApi = {
  checkIn: async (startTime?: string): Promise<any> => {
    const response = await api.post(
      '/api/attendance/check-in',
      startTime ? { start_time: startTime } : {},
    );
    return response.data;
  },
  checkOut: async (endTime?: string): Promise<any> => {
    const response = await api.post(
      '/api/attendance/check-out',
      endTime ? { end_time: endTime } : {},
    );
    return response.data;
  },
  updateToday: async (data: { start_time?: string; end_time?: string }): Promise<any> => {
    const response = await api.put('/api/attendance/today', data);
    return response.data;
  },
  /** Admin only — deletes today's row for the current user (test reset). */
  deleteTodayAdmin: async (): Promise<any> => {
    const response = await api.delete('/api/attendance/today');
    return response.data;
  },
  getToday: async (): Promise<any> => {
    const response = await api.get('/api/attendance/today');
    return response.data;
  },
  getRecords: async (month?: string): Promise<any> => {
    const response = await api.get('/api/attendance/records', { params: { month } });
    return response.data;
  },
  getTeam: async (date?: string, orgUnitId?: number): Promise<any> => {
    const response = await api.get('/api/attendance/team', { params: { date, org_unit_id: orgUnitId } });
    return response.data;
  },
  getEmployeeRecords: async (employeeId: string, month?: string): Promise<any> => {
    const response = await api.get(`/api/attendance/records/${employeeId}`, { params: { month } });
    return response.data;
  },
  adminCorrection: async (data: { employee_id: string; work_date: string; field: string; new_value: string; reason?: string }): Promise<any> => {
    const response = await api.post('/api/attendance/admin-correction', data);
    return response.data;
  },
  getSchedules: async (): Promise<any> => {
    const response = await api.get('/api/attendance/schedules');
    return response.data;
  },
  createSchedule: async (data: any): Promise<any> => {
    const response = await api.post('/api/attendance/schedules', data);
    return response.data;
  },
  getOfficeNetworks: async (): Promise<any> => {
    const response = await api.get('/api/attendance/office-networks');
    return response.data;
  },
  addOfficeNetwork: async (data: { range_name: string; ip_range: string; range_type?: string }): Promise<any> => {
    const response = await api.post('/api/attendance/office-networks', data);
    return response.data;
  },
  getHolidays: async (year?: number): Promise<any> => {
    const response = await api.get('/api/attendance/holidays', { params: { year } });
    return response.data;
  },

  // Phase 3: Remote Work Requests
  createRemoteRequest: async (data: { request_date: string; reason?: string }): Promise<any> => {
    const response = await api.post('/api/attendance/remote-requests', data);
    return response.data;
  },
  getMyRemoteRequests: async (status?: string): Promise<any> => {
    const response = await api.get('/api/attendance/remote-requests', { params: { status } });
    return response.data;
  },
  getPendingRemoteRequests: async (orgUnitId?: number): Promise<any> => {
    const response = await api.get('/api/attendance/remote-requests/pending', { params: { org_unit_id: orgUnitId } });
    return response.data;
  },
  approveRemoteRequest: async (requestId: number): Promise<any> => {
    const response = await api.put(`/api/attendance/remote-requests/${requestId}/approve`);
    return response.data;
  },
  rejectRemoteRequest: async (requestId: number): Promise<any> => {
    const response = await api.put(`/api/attendance/remote-requests/${requestId}/reject`);
    return response.data;
  },
  withdrawRemoteRequest: async (
    requestId: number,
    body?: { reason?: string },
  ): Promise<any> => {
    const response = await api.post(
      `/api/attendance/remote-requests/${requestId}/withdraw`,
      body ?? {},
    );
    return response.data;
  },

  // Phase 3: Anomaly Detection
  getAnomalies: async (): Promise<any> => {
    const response = await api.get('/api/attendance/anomalies');
    return response.data;
  },

  // Phase 3: Monthly Export
  exportAttendance: async (month: string, orgUnitId?: number): Promise<Blob> => {
    const response = await api.get('/api/attendance/export', {
      params: { month, org_unit_id: orgUnitId },
      responseType: 'blob',
    });
    return response.data;
  },

  // Phase 3: Audit Logs
  getAuditLogs: async (employeeId?: string, limit?: number): Promise<any> => {
    const response = await api.get('/api/attendance/audit-logs', { params: { employee_id: employeeId, limit } });
    return response.data;
  },
};
